import { useQuery } from "@tanstack/react-query";
import { client } from "@/api/client";

export const authQueryOptions = () => {
	return {
		queryKey: ["auth"],
		queryFn: async () => {
			const response = await client.auth.me.$get(
				{},
				{
					init: {
						credentials: "include",
					},
				},
			);

			if (response.status === 200) {
				const data = await response.json() as { username?: string | null };
				return data.username ?? null;
			}

			return null;
		},
	};
};

export const useAuthQuery = () => {
	return useQuery(authQueryOptions());
};
